import { View, StyleSheet } from 'react-native';
import { Text, theme } from '@socrait/react';

export function OrDivider() {
  return (
    <View style={styles.container}>
      <View style={styles.line} />
      <Text style={styles.text}>OR</Text>
      <View style={styles.line} />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing.medium,
    alignSelf: 'stretch',
  },
  line: {
    flex: 1,
    height: 1,
    backgroundColor: theme.colors.gray,
  },
  text: {
    fontSize: theme.fontSizes.xsmall,
    fontFamily: theme.fonts.medium,
    color: theme.colors.darkGray,
  },
});
